import { render } from "./GraficosIndicadoresProjetos.vue?vue&type=template&id=1e60b8a6&scoped=true"
import script from "./GraficosIndicadoresProjetos.vue?vue&type=script&lang=js"
export * from "./GraficosIndicadoresProjetos.vue?vue&type=script&lang=js"

import "./GraficosIndicadoresProjetos.vue?vue&type=style&index=0&id=1e60b8a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e60b8a6"]])

export default __exports__